import {useMemo} from 'react';
import {FetchComplianceResponse} from '../../lib/types';

/**
 * Hook to select the appropriate specialty data source
 * Uses defaultComplianceScores if available, otherwise falls back to complianceScores
 */
export function useSpecialtyDataSource(
    defaultComplianceScores: FetchComplianceResponse,
    complianceScores: FetchComplianceResponse
): FetchComplianceResponse {
    return useMemo(() => {
        return defaultComplianceScores.length > 0
            ? defaultComplianceScores
            : complianceScores;
    }, [defaultComplianceScores, complianceScores]);
}
